<template>
	<div>
		<side-bar icon="dashboard" :title="get_title" search v-model="search_text">

			<template v-slot:buttons>
				<k-btn icon no-margin v-tooltip="'Instances'" @click="main_tab='instances'" :active="main_tab == 'instances'"><k-icon small>settings_ethernet</k-icon></k-btn>
				<k-btn icon no-margin v-tooltip="'Channels'" @click="main_tab='channels'" :active="main_tab == 'channels'"><k-icon small>movie</k-icon></k-btn>
				<k-btn icon no-margin v-tooltip="'UTX Cores'" @click="main_tab='utx_cores'" :active="main_tab == 'utx_cores'"><k-icon type="symbols" small>desktop_cloud</k-icon></k-btn>
				<k-btn icon no-margin v-tooltip="'Transcoders'" @click="main_tab='transcoders'" :active="main_tab == 'transcoders'"><k-icon small>switch_video</k-icon></k-btn>
<!--				<k-tabs v-model="main_tab">
					<k-tab label="Instances" name="instances"></k-tab>
					<k-tab label="Channels" name="channels"></k-tab>
				</k-tabs>-->
     	</template>

     	<template v-slot:twosubheader v-if="$is_admin()">
	      <template v-if="main_tab=='instances'">
					<k-tabs grow v-model="instances_tab" style="margin-top: var(--ks-margin-1); margin-bottom: var(--ks-margin-2);">
						<k-tab name="input" label="Input"></k-tab>
						<k-tab name="output" label="Output"></k-tab>
						<k-tab name="system" label="System"></k-tab>
						<k-tab name="servers" label="Servers"></k-tab>
					</k-tabs>
    	  </template>

    	  <template v-if="main_tab == 'channels'">
  	      <k-tabs grow v-model="channels_tab" style="margin-top: var(--ks-margin-1); margin-bottom: var(--ks-margin-2);">
        		<k-tab name="online" label="Online"></k-tab>
        		<k-tab name="pull" label="Pull"></k-tab>
    	    </k-tabs>
     	  </template>
 
      </template>
      	<k-list bordered :items="instances" v-if="main_tab=='instances'" key="instances" @click="open_instance_menu">


      		<template #default="{ item }">
						{{title(item)}}
      		</template>
      		<template #subtitle="{ item }">
						{{channel_title_for_instance(item)}}
      		</template>

      		<template #left="{ item }">
							<template v-if="version_found(item)">
								<k-icon :color="version_color(item)" small v-tooltip="version(item)">update</k-icon>
							</template>
							<template v-if="!version_found(item) && !is_server(item)">
								<k-icon color="danger" small v-tooltip="'Version not found'">warning</k-icon>
							</template>
      		</template>
      		<template #menu="{ item }">
						<k-menu offset-x :close-on-content-click="false" v-model="instance_menu[item.id]" style="width: 100%;" :transition="false">
							<div v-if="instance_menu[item.id] && $is_admin()">
								<Instance v-model="instance_menu[item.id]" :instance="item"/>
							</div>
						</k-menu>
      		</template>
      	</k-list>

      	<k-list bordered :items="channels" v-if="main_tab=='channels'" key="channels" @click="(item) => {open_channel(item.channel)}">
      		<template #left="{ item }">
      			<k-icon :color="get_icon_color(item)" small>circle</k-icon>
      		</template>
      		<template #default="{ item }">
      			<div>
      				<channel-title grid :channel="item.channel" :alternative="item.alternative"></channel-title>
      			</div>
      		</template>
      		<template #subtitle="{ item }">
						<div style="text-transform: capitalize;">{{item.state || 'offline'}}</div>
					</template>
      		<template #right="{ item }">

						<k-btn icon no-margin v-tooltip="'Restart'"><k-icon small @click.stop="stop_source(item)">autorenew</k-icon></k-btn>

						<template v-if="channels_tab == 'pull' || item.state != ''">
							<k-btn
								icon
								no-margin
								:key="`channel-action-${item.key}-${channels_tab}-${item.state || 'empty'}`"
								v-tooltip="channels_tab == 'pull' && item.state == '' ? 'Start' : 'Stop'"
							>
								<k-icon small @click.stop="channels_tab == 'pull' && item.state == '' ? start_router(item) : stop_router(item)">{{channels_tab == 'pull' && item.state == '' ? 'play_circle_outline' : 'stop'}}</k-icon>
							</k-btn>
						</template>

      		</template>
      	</k-list>

      	<k-list bordered :items="instances" v-if="main_tab == 'transcoders'" key="transcoders" @click="open_event_menu">

      		<template #left="{ item }">
      			<!-- FIXME: Tähän varmaan eventin alkuaika -->
      		</template>

					<template #default="{ item }">
						<event-title :uuid="item.meta.events[0]"></event-title>
      		</template>
      		<template #subtitle="{ item }">
						{{channel_title_for_instance(item)}}
      		</template>

      		<template #right="{ item }">
							<k-btn icon no-margin><k-icon small @click.stop="stop_transcoder(item)">stop</k-icon></k-btn>
      		</template>
      		<template #menu="{ item }">
<!--						<k-menu offset-x :close-on-content-click="false" v-model="instance_menu[item.id]" style="width: 100%;" :transition="false" :close-on-click="false">
							<div v-if="instance_menu[item.id] && $is_admin()">
								<Instance v-model="instance_menu[item.id]" :instance="item"/>
							</div>
						</k-menu>-->
      		</template>
      	</k-list>

      	<k-list bordered :items="instances" v-if="main_tab == 'utx_cores'" key="utx_cores" @click="open_instance_menu">
					<template #left="{ item }">
					</template>
					<template #default="{ item }">
							{{channel_title_for_instance(item)}}
					</template>
					<template #subtitle="{ item }">
						{{title(item)}}
					</template>
      		<template #right="{ item }">
							<k-btn icon no-margin><k-icon small @click.stop="stop_transcoder(item)">stop</k-icon></k-btn>
      		</template>
      		<template #menu="{ item }">
						<k-menu offset-x :close-on-content-click="false" v-model="instance_menu[item.id]" style="width: 100%;" :transition="false">
							<div v-if="instance_menu[item.id] && $is_admin()">
								<Instance v-model="instance_menu[item.id]" :instance="item"/>
							</div>
						</k-menu>
      		</template>


				</k-list>
		</side-bar>

  </div>
</template>

<script>
import InstanceModel from '@/models/instance.js'
import ChannelModel from '@/models/channel.js'
import Instance from './Instance'
import Vue from 'vue'
import SideBar from '@/components/SideBar.vue'
import naturalSort from 'natural-sort'
import ChannelTitle from '@/components/ChannelTitle.vue'
import EventTitle from '@/components/EventTitle.vue'

export default {
	props: ["default_tab"],
	components: {
		Instance,
		SideBar,
		ChannelTitle,
		EventTitle
	},
	data () {
		return {
			instances_tab: "input",
			channels_tab: "online",
			main_tab: this.default_tab || "instances",
			instance_menu: {},
			channel_menu: {},
			search_text: "",
			latest_version: "",
			natural_sort: naturalSort()

		}
	},
	computed: {
		get_title () {
			if (this.main_tab == 'instances') return "Instances";
			if (this.main_tab == 'channels') return "Channels";
			if (this.main_tab == 'transcoders') return "Transcoders";
			if (this.main_tab == 'utx_cores') return "UTX Cores";
		},
		channels () {
			var self = this;
			var ret = [];
			if (this.channels_tab == "online") {
				ret = this.online_channels;
			}
			if (this.channels_tab == "pull") {
				ret = this.pull_channels;
			}

			var search = (this.search_text || "").toLowerCase();
			if (search.length > 0) {
				ret = _.filter(ret, function(ch_data) {
					ret = false;
					if (ChannelModel.title(ch_data.channel).toLowerCase().includes(search)) ret = true;
					if (ChannelModel.get_alternative_title(ch_data.alternative, ch_data.channel).toLowerCase().includes(search)) ret = true;
					return ret;
				})
			}
			return ret.sort((a, b) => {
				return self.natural_sort(ChannelModel.title(a), ChannelModel.title(b));
			});
		
			return ret;
		},
		pull_channels() {
			var ret =  _.filter(ChannelModel.list_active_channels(), (channel) => {
				return ChannelModel.is_pull(channel);
			});
			ret = _.map(ret, (channel) => {				
				var alternative = "";
				var headend = "";
				var data = ChannelModel.status(channel);
				var state = "";
				if (typeof(data) != "undefined") {
					headend = data.headend_instance;
				  state = _.get(this.get_source_state(data), "state", "");
				}
				return {key: channel.uuid, state: state, channel: channel, alternative: alternative, url: InstanceModel.headend_preview_url(headend, channel.uuid, alternative)};
			});
			return ret;
		},
 		online_channels () {
			var st = ChannelModel.status_all();
			if (typeof(st) != "undefined") {
				var res = [];
        _.each(st, (data, id) => {
          var headend = this.all_instances[data.headend_instance];
					var state = _.get(this.get_source_state(data), "state", "");
          if (typeof(headend) != "undefined") {
            var uuid = id.split(":")[0];
            var alternative = id.split(":")[1] || "";
            var channel = ChannelModel.channel_by_uuid(uuid);
            if(channel) res.push({key: id, state: state, channel: channel, alternative: alternative, url: InstanceModel.headend_preview_url(headend, uuid, alternative)});
          }
        });
        return res;
			}
			return [];
		},
		all_instances() {
      return this.$store.state.instances;
    },
    instances () {
			var self = this;
			var ret = [];
			if (this.main_tab == "transcoders") {
				ret = InstanceModel.instances_by_type("transcoder");
			} else if (this.main_tab == 'utx_cores') {
				ret = InstanceModel.instances_by_type("input");
				ret = _.filter(ret, (instance) => {
					var ch = InstanceModel.channel(instance);
					return ChannelModel.is_cloudstreamer(ch);
				});
			} else if (this.main_tab == "instances") {
				var type = this.instances_tab;
				if(type == "servers") {
					ret = _.concat(
						InstanceModel.instances_by_type("headend"),
						InstanceModel.instances_by_type("mediamtx"),
						InstanceModel.instances_by_type("clipper"),
						InstanceModel.instances_by_type("srt_server"),
						InstanceModel.instances_by_type("analyzer")
					);
				} else {
					if (type == "system") {
						ret = _.concat(
							InstanceModel.instances_by_type("input"),
							InstanceModel.instances_by_type("output")
						);
					} else {
						ret = InstanceModel.instances_by_type(type);
					}
					ret = _.filter(ret, function(instance) {
						var ch = InstanceModel.channel(instance);
						if (typeof(ch) == "undefined") return true;
						if (type == "system") {
							return ch.meta["system_channel"] === true;
						} else {
							return ch.meta["system_channel"] !== true;
						}
					});
				}
			}
			var search = (this.search_text || "").toLowerCase();
			if (search.length > 0) {
				ret = _.filter(ret, function(instance) {
					ret = false;
					if (self.title(instance).toLowerCase().includes(search)) ret = true;
					if (self.channel_title_for_instance(instance).toLowerCase().includes(search)) ret = true;
					return ret;
				})
			}
			return ret.sort((a, b) => {
				return self.natural_sort(self.title(a), self.title(b));
			});
		
    }
  },
  mounted () {
  	this.load_latest_version();
  },
  methods: {
  	open_instance_menu (item) {
  		var self = this;
	  	Vue.set(this.instance_menu, item.id, !this.instance_menu[item.id]);
	  	// Pitäs piilottaa muut
	  	_.each(this.instances, (instance) => {
	  		if (instance.id != item.id) {
	  			Vue.set(self.instance_menu, instance.id, false);
	  		}
	  	})

  	},
  	open_event_menu(instance) {
  		this.$router.push("/dashboard/event/" + instance.meta.events[0]);
  	},
  	open_channel(channel) {
      if (this.$is_admin()) {
          this.$router.push("/dashboard/channel/" + channel.uuid );
      }
  	},
  	start_router(ch_data) {
      ChannelModel.port_request(ch_data.channel, "", (msg) => {
      	console.log("Channel started", msg);
      }, (msg) => {
      	console.log("Cannot start channel", msg);
      });
  	},
  	stop_router(ch_data) {
  		ChannelModel.stop_channel(ch_data.channel.uuid, ch_data.alternative, (msg) => {
  			console.log("Channel stopped", msg);
  		}, (msg) => {
  			console.log("Cannot stop channel",msg);
  		});
  	},
  	stop_source(ch_data) {
  		ChannelModel.stop_source(ch_data.channel.uuid, ch_data.alternative, (msg) => {
  			console.log("Channel source stopped", msg);
  		}, (msg) => {
  			console.log("Cannot stop channel source", msg);
  		})
  	},
  	stop_transcoder(instance) {
  		var self = this;
  		var ch = InstanceModel.channel(instance);
  		var target = "Transcoder";

  		if (ChannelModel.is_cloudstreamer(ch)) {
  			target = "UTX Core";
  		}

  		InstanceModel.stop_transcoder(instance, (msg) => {
  			self.$message.success(target + " stopped");
  		}, (err) => {
  			self.$message.success(target + " stop failed!" + JSON.stringify(err));
  		});
  	},
  	get_state(data, type) {
			var i = data.instance;
			if (typeof(i) != "undefined") {
				var s = i[type];
				if (typeof(s) != "undefined") {
					return s;
				}
			}
			return;
		},
		get_source_state(data) {
			return this.get_state(data, "source");
		},
  	load_latest_version () {
  		var self = this;
  		var url = "kepitstreamer/3/update/latest"
  		Vue.http.get(url).then((response) => {
        self.latest_version = _.get(response, "body.latest.version", "");
      }, (response) => {
      });
  	},

    title (instance) {
      return InstanceModel.title(instance);
    },
    version (instance) {
      return InstanceModel.streamer_version(instance);
    },
    get_icon_color(item) {
			if (item.state == "connected") return "success";
			if (item.state == "connecting") return "warning";
			if (item.state == "listening") return "warning";
			if (item.state == "disconnected") return "warning";
			return "primary";
		},
    version_color (instance) {
    	if (this.latest_version == "") return "primary";
     	var v = this.version(instance);
     	if (!v.startsWith("v1")) {
	    	if (v != this.latest_version) return "danger";
	    }
    	return "success";
    },
    version_found (instance) {
    	var v = this.version(instance);
    	if (v == "" || typeof(v) == "undefined" || v == null) return false;
    	return true;
    },
  	channel_title_for_instance (instance) {
      var ch = InstanceModel.channel(instance);
      return ChannelModel.title(ch);
    },
    is_server(instance) {
    	return _.includes(["headend", "mediamtx", "clipper", "srt_server", "analyzer"], instance.type)
    }
  }
}
</script>
<style scoped>
	.offline-channel {
		opacity: 0.4;
	}
</style>
